import React, { useEffect } from "react";
import { Hero } from "./Hero";
import { BrandsSection } from "./BrandsSection";
import { VisionSection } from "./VisionSection";
import { ProductsSection } from "./ProductsSection";


import InputDesign from "./Sections/InputDesign";
import { MapSection } from "./MapSection";
import { setSelected } from "../store/reducers/CartReducer";
import { useDispatch, useSelector } from "react-redux";


export default function Home() {
  const dispatch = useDispatch()
  useEffect(() => {
  dispatch( setSelected({select:0}))
}, []);

const lang = useSelector((state) => state.cart.lang);
  return (
    <>
  
      
        <Hero lang={lang} />
        <BrandsSection  lang={lang}/>
        <VisionSection lang={lang} />
        <InputDesign  />
        <ProductsSection lang={lang} />
        <MapSection lang={lang} />
      
    </>
  );
}